import { useEffect, useRef } from 'react';

const REFRESH_INTERVAL = 120000;

/**
 * Laedt den Zaehler eines Badges beim Mount, beim Zurueckkehren ins Fenster und bei Socket-Events
 * zur Ressource (jeweils hoechstens alle 2 Minuten). Die Listener werden beim Unmount (Logout)
 * wieder entfernt: danach ist die Liste zurueckgesetzt und ein alter Listener wuerde beim
 * naechsten Fokus mit 'List ... must be initialized first!' abstuerzen.
 */
export const useBadgeRefresh = (handlePage, resource) => {
    const fetchStamp = useRef(Date.now());

    useEffect(() => {
        handlePage(null, 1, true);
        fetchStamp.current = Date.now();

        const isDue = () => {
            const now = Date.now();
            if (now - fetchStamp.current > REFRESH_INTERVAL) {
                fetchStamp.current = now;
                return true;
            }
            return false;
        };

        const handleFocus = () => {
            if (isDue()) {
                handlePage(null, 1, true);
            }
        };

        let refreshTimeout = null;
        const handleEvent = (e) => {
            if (e.model === resource && !document.hidden && isDue()) {
                refreshTimeout = setTimeout(() => {
                    handlePage(null, 1, true);
                }, Math.floor(Math.random() * REFRESH_INTERVAL));
            }
        };

        const echo = window.Echo;
        window.addEventListener('focus', handleFocus);
        if (echo) {
            echo.private('private').listen('Event', handleEvent);
        }

        return () => {
            window.removeEventListener('focus', handleFocus);
            if (echo) {
                echo.private('private').stopListening('Event', handleEvent);
            }
            clearTimeout(refreshTimeout);
        };
    }, [handlePage, resource]);
};
